import { DocumentIsogd } from "isogd-document-rest";

class DocumentRegistrationViewController {
    private document: DocumentIsogd;
}

export const DocumentRegistrationViewComponent: angular.IComponentOptions = {
    controller: DocumentRegistrationViewController,
    template: require('./documentRegistrationView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-registration/documentRegistrationView.ts